/**
 *
 *
 */

/* 배송상태 */
export const PURCHASE_STATUS = {
  PENDING: {
    value: 'PENDING',
    title: '구매확정전',
    color: 'blue',
  },
  CONFIRMED: {
    value: 'CONFIRMED',
    title: '구매확정',
    color: 'green',
  },
  REFUNDED: {
    value: 'REFUNDED',
    title: '환불',
    color: 'volcano',
  },
  RETURNED: {
    value: 'RETURNED',
    title: '반품',
    color: 'magenta',
  },
  CALCULATE: {
    value: 'CALCULATE',
    title: '정산완료',
    color: 'purple',
  },
};

/* 주문 상태 */
export const ORDER_STATUS = {
  READY: {
    label: '준비전',
    title: '준비전',
    color: 'blue',
  },
  PREPARING: { label: '준비중', title: '준비중', color: 'orange' },
  COMPLETED: {
    label: '완료',
    title: '완료',
    color: 'green',
  },
  CANCELLED: {
    label: '결제취소',
    title: '결제취소',
    color: 'red',
  },
};

export const ORDER_ROUTE = {
  POS: { label: '포스', title: '포스', value: 'POS' },
  KIOSK: {
    label: '키오스크',
    title: '키오스크',
    value: 'KIOSK',
  },
  APP: { label: '앱', title: '앱', value: 'APP' },
};
